<div class="sidebar-menu" id="menu-wrapper" data-qa="core">
  <!-- #region HEADER -->
  <!-- ----------------------------------------------------------------------------------------------- -->
  <horizon-sidebar-menu
    class="sidebar-menu__header"
    [sideBarMenuConfig]="menuSettingsService.sidebarMenuConfig"
    [menuRoutingPaths]="menuRoutingPaths"
    [menuItemsPermissions]="menuItemsPermissions"
    [mainFontColor]="globalSettings.colors.mainColor"
    [applyPermissions]="true"
    *ngIf="showHeader"
  >
    <div sidebar>
      <horizon-app-header
        [canUserSearch]="canUserSearch"
        [currentLanguage]="currentLanguage"
        [dataRecentsSearch]="dataRecentsSearch"
        [hasRecentsSearch]="true"
        [logoImg]="headerSettingsService.headerSettings.logoImg"
        [mainFontColor]="globalSettings.colors.mainColor"
        [recentSearchLayout]="recentSearchContent"
        [secondaryFontColor]="globalSettings.colors.tertiaryColor"
        [showLogoImg]="headerSettingsService.headerSettings.showLogoImg"
        [showSearch]="headerSettingsService.headerSettings.showSearch"
        [showSystemDate]="true"
        [showToolbarActions]="headerSettingsService.headerSettings.showToolbar"
        [showUserAvatar]="headerSettingsService.headerSettings.showUserAvatar"
        [showUserOptionsMenu]="
          headerSettingsService.headerSettings.showUserOptionsMenu
        "
        [systemDate]="systemDate"
        [templateRecentSearch]="templateRecentSearch"
        [textSearchInput]="true"
        [toolbarOptions]="headerSettingsService.toolbarOptions"
        [user]="user"
        [userOptionsMenuItems]="headerSettingsService.customMenuOptions"
        [userPhoto]="userPhoto"
        (logoImgClicked)="goHome()"
        (searchClicked)="onSearch($event)"
        (languageChanged)="languageChanged($event)"
        (totalData)="totalData()"
        (updateData)="updateData($event)"
        (logoutClicked)="logout()"
        (selectItemClicked)="selectItemClick($event)"
        (toolbarItemClicked)="onToolbarItemClicked($event)"
      >
        <!--componente recent-search-->
      </horizon-app-header>
      <horizon-genesys-telephony
        *ngIf="startGenesysTelephony"
        [showGenesysTelephony]="showGenesysTelephony"
        [showIncomingCallNotification]="showIncomingCallNotification"
        (genesysLogout)="genesysLogout()"
      ></horizon-genesys-telephony>
    </div>
  </horizon-sidebar-menu>

  <!--endregion -->

  <!-- #region CONTENT -->
  <!-- ----------------------------------------------------------------------------------------------- -->
  <div class="sidebar-menu__main" id="main-text" data-qa="core_sidebar">
    <div class="sidebar-menu__main--content">
      <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>
  </div>
  <!--endregion -->
</div>

<!-- #region TOAST -->
<horizon-toast-notification
  data-qa="core_prism-toast-notification"
  [toast]="newNotification"
></horizon-toast-notification>
<!-- #endregion -->

<!-- #region NOTIFICATIONS -->
<horizon-dialog-notification-modal
  data-qa="core_prism-dialog-notification-modal"
  [dialogNotificationObj]="notificationsDialog"
  [dialogWidth]="'500'"
  (confirmModal)="confirmModal($event)"
  (cancelModal)="cancelModal()"
></horizon-dialog-notification-modal>
<!-- #endregion -->

<!-- #region LOADING -->
<horizon-dialog-loading-modal
  *ngIf="showLoadingSpinner"
  [dialogTitle]="'horizon.loading'"
></horizon-dialog-loading-modal>
<!-- #endregion -->

<!-- #region open Genesys Substitute modal -->
<horizon-genesys-temporal-substitute
  *ngIf="showGenesysSubstituteModal"
  (closeSubstitute)="closeGenesysSubstituteModal($event)"
></horizon-genesys-temporal-substitute>
<!-- #endregion -->

<!-- #region open log modal -->
<horizon-genesys-call-log
  *ngIf="showCallLog"
  [isEditMode]="true"
  [callLogOrigin]="callLogOrigin"
  (closeEvent)="closeCallLog($event)"
></horizon-genesys-call-log>
<!--#endregion-->
